"use client";

import Image from "next/image";
import Link from "next/link";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return (
        <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background">
            <div className="absolute inset-0 animate-gradient-x bg-gradient-to-r from-slate-200/50 via-blue-200/30 to-slate-200/50 dark:from-slate-800/50 dark:via-blue-900/30 dark:to-slate-800/50" />
            <div className="relative w-full max-w-md rounded-2xl border border-border bg-card p-8 shadow-xl">
                <div className="mx-auto flex h-20 w-24 items-center justify-center">
                    <Image
                        src="/contract-rabbit-logo-main.png"
                        alt="Contract Rabbit"
                        width={88}
                        height={72}
                        className="object-contain"
                        style={{ width: 88, height: 72 }}
                    />
                </div>
                <div className="mt-6 text-center">
                    <h1 className="text-2xl font-semibold text-foreground">Something went wrong</h1>
                    <p className="mt-3 text-sm text-muted-foreground">
                        An unexpected error occurred. Our team has been notified.
                    </p>
                    {error.digest && (
                        <p className="mt-2 font-mono text-xs text-muted-foreground/60">Error ID: {error.digest}</p>
                    )}
                    <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
                        <button
                            onClick={() => reset()}
                            className="inline-flex items-center justify-center rounded-lg bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground shadow-lg transition-all hover:bg-primary/90 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                        >
                            Try Again
                        </button>
                        <Link
                            href="/"
                            className="inline-flex items-center justify-center rounded-lg border border-border bg-background px-5 py-2.5 text-sm font-medium text-foreground transition-colors hover:bg-muted focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                        >
                            Go Home
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
